export default __webpack_public_path__ + "static/media/Snd_V_Starts.e0cc5aec.mp3";